import DetailBottomButtons from "@/components/common/DetailBottomButtons"
import DetailEntityInfo from "../common/DetailEntityInfo";
import Popup from "@/components/common/Popup"
import OperatorSelect from "@/components/common/OperatorSelect"

import tabs from "@/components/mixins/tabs"
import message from "@/components/mixins/message"
import userSettings from "@/components/mixins/user-settings"
import popup from "@/components/mixins/popup"
import requiredFields from "@/components/mixins/required-fields"
import selectOperatorBusinessModel from "@/components/mixins/select-operator-business-model"

export default {
	components: {DetailBottomButtons, Popup, DetailEntityInfo, OperatorSelect},
	mixins: [tabs, message, userSettings, popup, requiredFields, selectOperatorBusinessModel],
	data() {
		return {
			loading: true,
			entityName: '',
			moduleName: '',
			tabName: '',
			detailPageRouteName: '',
			entity: {},
			updateFields: [],
			dateFields: [],
			datetimeFields: [],
			fieldsToResetOnSuccess: [],
		}
	},
	computed: {
		hasName() {
			return this.entity.surname || this.entity.firstname
		},
		companyTown() {
			let companyTown = ''
			if (this.entity.company_name || this.entity.address.town) {
				companyTown += ' | '
				if (this.entity.company_name) {
					companyTown += this.entity.company_name
				}
				if (this.entity.address.town) {
					companyTown += ' (' + this.entity.address.town + ')'
				}
			}
			return companyTown
		},
		isActive() {
			return this.entity.active
		},
		$_deleteActionAllowed() {
			if(!this.entity){
				return false;
			}
			return this.$_loggedUser_operator_item_delete_action_allowed(this.entity.id_operator);
		},
		$_updateActionAllowed() {
			if(!this.entity){
				return false;
			}
			return this.$_loggedUser_operator_item_update_action_allowed(this.entity.id_operator);
		},
	},
	methods: {
		redirect(routeName, params = null) {
			if (params === null) {
				this.$router.push({name: routeName})
			} else {
				this.$router.push({name: routeName, params: params})
			}
		},
		openRoute(routerName) {
			this.$router.push({
				name: routerName
			})
		},
		createdInit() {
			return this.getEntity()
				.then(() => {
					this.loading = false
					this.saveLastVisited(this.entity.id)
				})
				.catch(error => {
					this.setErrorMessage(error['error_message'])
				})
		},
		submitForm(redirect = false, redirectParams = null) {
			this.updateEntity(this.entity, redirect, redirectParams)
		},
		executePopupAction(value) {
			if (value === true) {
				if (this.getPopupAction === 'delete') {
					this.deleteEntity(false, this.getPopupSpecification)
				}
			}
			this.hidePopup()
		},
		getEntity(hideLoadingMessage = false) {
			this.setLoadingMessage();
			let id = null;
			let params = {id_selected_operator: this.$_loggedUser_selectedOperatorId};
			if(this.$route.params.remote){
				id = this.$route.params.remote;
				params['remote'] = true;
			}else{
				id = this.$route.params.id;
			}
			return this.entityService.getEntity(id, params)
				.then(data => {
					this.emptyMessage()
					this.entity = data[this.entityName]
					this._afterGetEntityActions(data)
				})
				.catch(function (error) {
					this.setErrorMessage(error['error_message'])
					if(this.moduleName){
						this.$router.push({name: this.moduleName})
					}
				}.bind(this))
		},
		createEntity(redirect = false, redirectParams = null) {
			let preProcessedParams = this._beforeCreateEntityActions({...this.entity})
			this.entityService.createEntity(this.filterFormParams(preProcessedParams))
				.then(data => {
					this.saveLastVisited(data.id)
					this.setSuccessMessage();
					if (redirect === true) {
						this.redirect(this.moduleName)
					} else {
						if(redirectParams){
							this.redirect(redirectParams.path, redirectParams.params)
						}else{
							this.redirect(this.detailPageRouteName, {id: data.id})
						}

					}
				})
				.catch(function (error) {
					this.setErrorMessage(this._processDetailErrorMessage(error))
				}.bind(this))
		},
		updateEntity(params, redirect = false, redirectParams = null) {
			let preProcessedParams = this._beforeUpdateEntityActions({...params})
			return this.entityService.updateEntity(this.entity.id, this.filterFormParams(preProcessedParams))
				.then((updateData) => {
					if (redirect === true) {
						if(redirectParams){
							this.redirect(redirectParams.path, redirectParams.params)
						}else{
							this.redirect(this.moduleName)
						}
					} else {
						this._resetFields()
						this.emptyMessage()
						this.setSuccessMessage()
						this.getEntity()
							.then(() => {
								this._afterUpdateEntityActions(updateData)
							})
					}
				})
				.catch(function (error) {
					this.setErrorMessage(this._processDetailErrorMessage(error))
				}.bind(this))
		},
		updateEntityActive(activeKey, activeValue) {
			let params = {}
			params[activeKey] = activeValue

			this.entityService.updateEntity(this.entity.id, params)
				.then(() => {
					this.emptyMessage()
					this.setSuccessMessage()
					this.entity[activeKey] = activeValue
				})
				.catch(function (error) {
					this.setErrorMessage(this._processDetailErrorMessage(error))
				}.bind(this))
		},
		deleteEntity(showPopup = true, redirectParams = null) {
			if (showPopup) {
				this.showPopup(null, 'delete', 'delete', redirectParams)
			} else {
				this.entityService.deleteEntity(this.entity.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(() => {
						if(redirectParams){
							this.redirect(redirectParams.path, redirectParams.params)
						}else {
							this.$router.push({name: this.moduleName})
						}
						this.setSuccessMessage(this.$gettext('Smazáno'));
					})
					.catch(function (error) {
						this.setErrorMessage(this._processDetailErrorMessage(error))
					}.bind(this))
			}
		},

		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					if (this.datetimeFields.includes(key)) {
						value = this.$_datetime_toMysqlFormatFromString(params[key])
					} else if ([...this.dateFields, ...['active_from', 'valid_from', 'active_to', 'valid_to']].includes(key)) {
						value = this.$_date_toMysqlFormatFromString(params[key])
					}

					allowed[key] = value
				}
			}.bind(this))

			if(this.$_get_section_type(this.$route.meta.sectionName) != 'global_only') {
				allowed['id_selected_operator'] = this.$store.getters.getSelectedOperatorId
			}

			return this._afterFilterFormParamsActions(params, allowed)
		},

		/* implement in components using this mixin only when needed */

		_resetFields() {
			this._.forEach(this.fieldsToResetOnSuccess, (ref) => {
				this.setFieldInvalid(ref)
			})
		},
		_beforeCreateEntityActions(params = null) {
			return params
		},
		_beforeUpdateEntityActions(params = null) {
			return params
		},
		_afterGetEntityActions() {
		},
		_afterUpdateEntityActions() {
		},
		_afterFilterFormParamsActions(params = null, allowed = null) {
			return allowed
		},
		_processDetailErrorMessage(error) {
			return error['error_message']
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/detail-actions.js